/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your data to build an area chart — a line chart with the region below each line filled in to emphasise magnitude. Use a first column for x-axis labels and numeric columns for each series.`)
};

const es_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tus datos para crear un gráfico de área — un gráfico de líneas con la región debajo de cada línea rellena para resaltar la magnitud. Usa una primera columna para las etiquetas del eje X y columnas numéricas para cada serie.`)
};

const de_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Ihre Daten ein, um ein Flächendiagramm zu erstellen — ein Liniendiagramm, bei dem der Bereich unterhalb jeder Linie ausgefüllt ist, um die Größenordnung zu betonen. Verwenden Sie eine erste Spalte für x-Achsen-Beschriftungen und numerische Spalten für jede Serie.`)
};

const nl_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak je data om een vlakdiagram te bouwen — een lijndiagram waarbij het gebied onder elke lijn is gevuld om de grootte te benadrukken. Gebruik een eerste kolom voor x-as-labels en numerieke kolommen voor elke reeks.`)
};

const fr_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez vos données pour créer un graphique en aires — un graphique en courbes dont la région sous chaque courbe est remplie pour mettre en valeur l'ampleur. Utilisez une première colonne pour les étiquettes de l'axe des x et des colonnes numériques pour chaque série.`)
};

const it_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla i tuoi dati per costruire un grafico ad area — un grafico a linee con la regione sotto ciascuna linea riempita per enfatizzare la grandezza. Usa una prima colonna per le etichette dell'asse x e colonne numeriche per ciascuna serie.`)
};

const pt_br2_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seus dados para criar um gráfico de área — um gráfico de linhas com a região abaixo de cada linha preenchida para enfatizar a magnitude. Use uma primeira coluna para os rótulos do eixo x e colunas numéricas para cada série.`)
};

const pt_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole os seus dados para construir um gráfico de área — um gráfico de linhas com a região abaixo de cada linha preenchida para realçar a magnitude. Use uma primeira coluna para os rótulos do eixo X e colunas numéricas para cada série.`)
};

const ja_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを貼り付けるとエリアチャートが作成されます — 各線の下の領域を塗りつぶして大きさを強調した折れ線グラフです。最初の列をx軸ラベルに、各系列に数値列を使用してください。`)
};

const zh_area_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴数据即可构建面积图——一种在每条线下方区域填色以突出数值大小的折线图。第一列用于 x 轴标签，数值列用于各个系列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_intro", locale)
	if (locale === "en") return en_area_intro(inputs)
	if (locale === "es") return es_area_intro(inputs)
	if (locale === "de") return de_area_intro(inputs)
	if (locale === "nl") return nl_area_intro(inputs)
	if (locale === "fr") return fr_area_intro(inputs)
	if (locale === "it") return it_area_intro(inputs)
	if (locale === "pt-BR") return pt_br2_area_intro(inputs)
	if (locale === "pt") return pt_area_intro(inputs)
	if (locale === "ja") return ja_area_intro(inputs)
	return zh_area_intro(inputs)
};